import './Footer.less';

/**
 * Компонент подвала
 */
const Footer: React.FC = () => {
    return (
        <div className="qpd-rstr-footer">
            <p>{process.env.REACT_APP_REESTR_SSO_PHONE}, {process.env.REACT_APP_REESTR_SSO_EMAIL}</p>
            <a href={process.env.REACT_APP_REESTR_SSO_TERMS_OF_USE}>Правила использования</a>
        </div>
    );
};

export default Footer;
